import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

// Navigation context only: retain the application's existing session and APIs.
export default function TruckingWorkspace() {
  const { user } = useAuth();
  return ["admin", "office", "super_admin"].includes(user?.role)
    ? <Outlet /> : <Navigate to="/app" replace />;
}
